import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { CASE_STAGE_KEY } from '../../utils/constants/queryKeys';
import { getCaseStage } from '../services/fn-api/Cases';
import { ICaseStageResponse } from '../types/Case';

export const useGetCaseStage = (caseId: number) => {
  return useQuery<ICaseStageResponse | null>({
    queryKey: [CASE_STAGE_KEY, caseId],
    // A 404 means AIDI has no record of this case yet (i.e. user hasn't started).
    // Treat it as a successful "null" result so it doesn't surface as an error. 
    queryFn: async () => {
      try {
        return await getCaseStage(caseId);
      } catch (err) {
        if (isAxiosError(err) && err.response?.status === 404) return null;
        throw err;
      }
    },
    enabled: !!caseId,
    retry: false,
    // This query drives first-entry vs returning-user routing (IDLE → splash, else → documents).
    // The stage flips the moment the user enters AIDI, so a cached null from a prior visit
    // would cause a returning user to be incorrectly routed back to the splash screen.
    // gcTime: 0 ensures the cache entry is dropped on unmount so the next navigation
    // starts a fresh fetch with isLoading=true, forcing the router to wait for real data. 
    staleTime: 0,
    gcTime: 0,
  });
};
